export const PlanHolderSortOptions = [
  { title: 'Company Type (default)', value: 'CompanyTypeSpecial' },
  { title: 'Company Type (A-Z)', value: 'CompanyType.Name' },
  { title: 'Company Name', value: 'CompanyName' },
  { title: 'First Name', value: 'FirstName' },
  { title: 'Last Name', value: '-LastName' }
];
